/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactpacktimesavedheadline4Inputs */

const en_artifactpacktimesavedheadline4 = /** @type {(inputs: Artifactpacktimesavedheadline4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saves you 8+ hours of legal formatting, statute matching, and exhibit work.`)
};

const pt_artifactpacktimesavedheadline4 = /** @type {(inputs: Artifactpacktimesavedheadline4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poupa-lhe 8+ horas de formatação legal, citações de artigos e numeração de documentos.`)
};

/**
* | output |
* | --- |
* | "Saves you 8+ hours of legal formatting, statute matching, and exhibit work." |
*
* @param {Artifactpacktimesavedheadline4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpacktimesavedheadline4 = /** @type {((inputs?: Artifactpacktimesavedheadline4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpacktimesavedheadline4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpacktimesavedheadline4(inputs)
	return pt_artifactpacktimesavedheadline4(inputs)
});
export { artifactpacktimesavedheadline4 as "artifactPackTimeSavedHeadline" }